// src/components/admin/AdminUsuarios.js
import React, { useState, useEffect } from 'react';
import { listarUsuarios, toggleBloqueoUsuario, actualizarLimitesUsuario, cambiarEstadoUsuario } from '../../services/api';

const AdminUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editando, setEditando] = useState(null);
  const [limitesTemp, setLimitesTemp] = useState({});
  const [mensaje, setMensaje] = useState({ type: '', text: '' });

  useEffect(() => {
    cargarUsuarios();
  }, []);

  const cargarUsuarios = async () => {
    setLoading(true);
    setError(null);
    try {
      //console.log('🔍 Cargando usuarios...');
      const response = await listarUsuarios();
      //console.log('✅ Usuarios recibidos:', response.data);
      setUsuarios(response.data.usuarios);
    } catch (error) {
      console.error('❌ Error cargando usuarios:', error);
      setError(error.message || 'Error al cargar usuarios');
      setMensaje({ type: 'error', text: 'Error al cargar usuarios' });
    } finally {
      setLoading(false);
    }
  };

  // Mostrar estado de carga
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando usuarios...</p>
      </div>
    );
  }

  // Mostrar error si ocurrió
  if (error) {
    return (
      <div className="error-container">
        <div className="error-icon">❌</div>
        <h3>Error al cargar usuarios</h3>
        <p>{error}</p>
        <button onClick={cargarUsuarios} className="btn-reintentar">
          Reintentar
        </button>
      </div>
    );
  }

  // Mostrar tabla
  return (
    <div className="admin-usuarios">
      <h2>👥 Gestión de Usuarios</h2>
      
      {mensaje.text && (
        <div className={`mensaje ${mensaje.type}`}>{mensaje.text}</div>
      )}

      {usuarios.length === 0 ? (
        <div className="empty-state">
          <p>No hay usuarios registrados</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="tabla-usuarios">
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuario</th>
                <th>Email</th>
                <th>Rol</th>
                <th>Estado</th>
                <th>Límite Imágenes</th>
                <th>Límite Texto</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.username}</td>
                  <td>{u.email}</td>
                  <td>
                    <span className={`rol-badge ${u.rol}`}>
                      {u.rol}
                    </span>
                  </td>
                  <td>
                    <span className={`estado-badge ${u.estado || 'pendiente'}`}>
                      {u.estado === 'activo' ? '✅ Activo' : '⏳ Pendiente'}
                    </span>
                  </td>
                  
                  {/* Límite Imágenes */}
                  <td>
                    {editando === u.id ? (
                      <input
                        type="number"
                        name="limite_imagenes_beta"
                        value={limitesTemp.limite_imagenes_beta}
                        onChange={(e) => setLimitesTemp({
                          ...limitesTemp,
                          limite_imagenes_beta: parseInt(e.target.value) || 0
                        })}
                        className="limite-input"
                        min="0"
                      />
                    ) : (
                      <span>{u.limite_imagenes_beta}</span>
                    )}
                  </td>
                  
                  {/* Límite Texto */}
                  <td>
                    {editando === u.id ? (
                      <input
                        type="number"
                        name="limite_texto_beta"
                        value={limitesTemp.limite_texto_beta}
                        onChange={(e) => setLimitesTemp({
                          ...limitesTemp,
                          limite_texto_beta: parseInt(e.target.value) || 0
                        })}
                        className="limite-input"
                        min="0"
                      />
                    ) : (
                      <span>{u.limite_texto_beta}</span>
                    )}
                  </td>
                  
                  <td>
                    <div className="acciones-container">
                      {editando === u.id ? (
                        <>
                          <button 
                            onClick={() => {
                              // Función para guardar límites
                              //console.log('Guardando límites para:', u.id, limitesTemp);
                              // Aquí iría la llamada a la API
                              setEditando(null);
                            }}
                            className="btn-guardar"
                            title="Guardar límites"
                          >
                            💾
                          </button>
                          <button 
                            onClick={() => setEditando(null)}
                            className="btn-cancelar"
                            title="Cancelar"
                          >
                            ❌
                          </button>
                        </>
                      ) : (
                        <>
                          <button 
                            onClick={() => {
                              setEditando(u.id);
                              setLimitesTemp({
                                limite_imagenes_beta: u.limite_imagenes_beta,
                                limite_texto_beta: u.limite_texto_beta
                              });
                            }}
                            className="btn-editar"
                            title="Editar límites"
                          >
                            ✏️
                          </button>
                          
                          {/* Botón de estado - VERSIÓN CORREGIDA */}
						<button 
						  onClick={() => {
							const nuevoEstado = u.estado === 'activo' ? 'pendiente' : 'activo';
							if (window.confirm(`¿${nuevoEstado === 'activo' ? 'Activar' : 'Poner en pendiente'} usuario?`)) {
							  //console.log('Cambiando estado de:', u.id, 'a', nuevoEstado);
							  // Aquí iría la llamada a la API
							}
						  }}
						  className={`btn-estado ${u.estado === 'activo' ? 'btn-activo' : 'btn-pendiente'}`}
						  title={u.estado === 'activo' ? 'Usuario activo (hacer clic para poner en espera)' : 'Usuario en espera (hacer clic para activar)'}
						>
						  {u.estado === 'activo' ? '✅' : '⏳'}
						</button>

                          <button 
                            onClick={() => {
                              const nuevoBloqueo = !u.bloqueado;
                              if (window.confirm(`¿${nuevoBloqueo ? 'bloquear' : 'desbloquear'} usuario?`)) {
                                //console.log('Cambiando bloqueo de:', u.id, 'a', nuevoBloqueo);
                                // Aquí iría la llamada a la API
                              }
                            }}
                            className={`btn-bloqueo ${u.bloqueado ? 'btn-desbloquear' : 'btn-bloquear'}`}
                            title={u.bloqueado ? 'Desbloquear' : 'Bloquear'}
                          >
                            {u.bloqueado ? '🔓' : '🔒'}
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminUsuarios;